const IGNORED_ERROR_MESSAGES = [
  // Network/Request errors
  'AbortError',
  'cancelled',
  'NetworkError',
  'Failed to fetch',

  // Script errors from third-party sources
  'Script error',
  'Network request failed',

  'Cannot redefine property: ethereum',
  "undefined is not an object (evaluating 'window.webkit.messageHandlers')",

  // Related to ad blockers being used
  'UET is not defined',
  "Can't find variable: UET",
]

// Error message patterns to ignore (regex)
const IGNORED_ERROR_PATTERNS = [/^attempted to hard navigate to the same url$/i]

// URLs to ignore errors from (partial matches)
const IGNORED_ERROR_SOURCES = ['doubleclick.net', 'segment.io', 'hotjar.com']

export function shouldIgnoreError(message?: string, source?: string): boolean {
  if (message) {
    if (IGNORED_ERROR_MESSAGES.some((ignored) => message.includes(ignored))) {
      return true
    }

    if (IGNORED_ERROR_PATTERNS.some((pattern) => pattern.test(message))) {
      return true
    }
  }

  if (source && IGNORED_ERROR_SOURCES.some((ignored) => source.includes(ignored))) {
    return true
  }

  return false
}
